import { Component } from 'react';

/**
 * Simple error boundary. If a child throws during render,
 * we log the error and render a friendly fallback instead of
 * letting the whole page go blank.
 */
class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('[ErrorBoundary]', error, info?.componentStack);
  }

  render() {
    if (this.state.error) {
      const { fallback } = this.props;
      if (fallback) {
        return typeof fallback === 'function'
          ? fallback(this.state.error, () => this.setState({ error: null }))
          : fallback;
      }
      return null;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
